import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class GetFiscalLocationInfoQuery {
    constructor(
        private readonly dispatcher: QueryDispatcher,
        private readonly frontend: any,
    ) { }

    async run(): Promise<any> {
        try {
            this.frontend.fiscal_locations = await this.dispatcher.dispatch('get.fiscal.location.info', {});
        } catch(error) {
            console.error("GetFiscalLocationInfoQuery - Error: ", error);
        }

        return {}
    }
}